import { useEffect, useRef } from 'react'

import { reactSelectStyles } from '@/utils/select.config'

type InlineEditInputProps = {
  value: string
  onChange: (value: string) => void
  onBlur: () => void
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void
  minWidth: number
}

/**
 * Inline edit input component for editing option labels
 * Automatically focuses and selects text on mount
 */
export function InlineEditInput({
  value,
  onChange,
  onBlur,
  onKeyDown,
  minWidth,
}: InlineEditInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  // Auto-focus and select text on mount
  useEffect(() => {
    const input = inputRef.current
    if (input) {
      input.focus()
      input.select()
    }
  }, [])

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      style={{
        ...reactSelectStyles.control({}),
        width: minWidth,
      }}
    />
  )
}
